module.exports = __webpack_public_path__ + "static/media/SD.aaf11d15.svg";